import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import { tableCloseNotificationAction, addToastAction } from 'data/reducers';
import { Notifications, ToastTypes, TableNotificationResponse } from 'types';
import { alerts } from 'constants/common';

export function* tableNotification({
  type: notificationType,
  data: result,
}: TableNotificationResponse) {
  try {
    if (notificationType === Notifications.NOTIFICATION) {
      if (result.notifyAbout === 'SHUFFLE') {
        yield put(addToastAction({ type: ToastTypes.WARNING, value: alerts.SHUFFLE }));
        return;
      }

      if (result.notifyAbout === 'CLOSE_GAME') {
        yield put(tableCloseNotificationAction());
        yield put(addToastAction({ type: ToastTypes.WARNING, value: alerts.TABLE_CLOSED }));
        return;
      }
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
